import React from 'react';
import Layout from '../../core/Layout';
import { Encabezado } from '../../core/Encabezado';
import { DocRow, DocSection, DocMigas } from '../DocComponentes';

class DocumentacionUsuario extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Documentación - Usuario">
                    <section className="paginaItmex docItmex">
                        <Encabezado
                            etiqueta="Documentación"
                            titulo="Documentación Usuario"
                            subtitulo="Guías y materiales para clientes de Red Itmex."
                        />
                        <DocMigas actual="Usuario" />

                        <DocSection
                            icon="fa-user"
                            title="Materiales para Usuarios"
                            subtitle="Documentos de bienvenida y guías de uso"
                        >
                            <DocRow
                                href="https://www.reditmex.com/documentacion/usuario/folleto-bienvenida/pdf/v1"
                                label="Folleto de Bienvenida"
                                version="v1" date="27/09/2022"
                            />
                        </DocSection>
                    </section>
                </Layout>
            </div>
        )
    }
}

export default DocumentacionUsuario;
